import { VisualType, ANIMATIONS } from '../constants';

export const getImageSource = (mediaType: VisualType, mediaSource: string) => {
  if (mediaType === VisualType.ANIMATION) {
    const animation = ANIMATIONS.find(({ id }) => id === mediaSource);
    return animation?.image;
  }
  return mediaSource;
};
